/**
 * Minisite (online booking) settings menu config. Used by SettingsMenu in
 * `'minisite'` nav mode.
 *
 * Hierarchy:
 *
 *   ONLINE BOOKING   Preferences · Theme · Site notice · Menu · Payments ·
 *                    New customers · Minimise gaps · Business info · Embed ·
 *                    Terms & policy · Pages · Advanced
 *
 * All routes live under `/minisite/*` — the split is in the sidebar
 * config only, not the URL space.
 */
export const groups = [
  {
    label: '',
    items: [
      { label: 'general.preferences', icon: 'lucide:settings', info: 'components.minisite.pages.preferences', path: '/minisite/preferences' },
      { label: 'general.theme', icon: 'lucide:palette', info: 'components.minisite.pages.theme', path: '/minisite/theme' },
      { label: 'minisite.pages.embed', icon: 'lucide:code', info: 'components.minisite.pages.embed', path: '/minisite/embed' },
      {
        label: 'minisite.pages.pages',
        icon: 'lucide:layout-grid',
        info: 'components.minisite.pages.pages',
        path: '/minisite/pages/booking',
        children: [
          { label: 'minisite.booking',           icon: 'lucide:calendar',  path: '/minisite/pages/booking' },
          { label: 'general.giftCards',          icon: 'lucide:gift',      path: '/minisite/pages/gift-cards' },
          { label: 'general.passes',             icon: 'lucide:ticket',    path: '/minisite/pages/passes' },
          { label: 'general.courses',            icon: 'lucide:graduation-cap', path: '/minisite/pages/courses' },
          { label: 'general.reviews',            icon: 'lucide:star',      path: '/minisite/pages/reviews' },
          { label: 'minisite.pages.customer',    icon: 'lucide:user',      path: '/minisite/pages/customer' },
          { label: 'minisite.pages.siteNotice',  icon: 'lucide:alert-triangle', path: '/minisite/site-notice' },
          { label: 'minisite.gallery',           icon: 'lucide:images',    path: '/minisite/pages/gallery' },
        ],
      },
      { label: 'minisite.pages.customPages', icon: 'lucide:file-plus', info: 'components.minisite.pages.customPages', path: '/minisite/pages/custom-pages' },
      { label: 'minisite.pages.menu', icon: 'lucide:menu', info: 'components.minisite.pages.menu', path: '/minisite/menu' },
      {
        label: 'minisite.pages.businessInfo',
        icon: 'lucide:building-2',
        info: 'components.minisite.pages.businessInfo',
        path: '/minisite/business-info',
        children: [
          { label: 'general.details', icon: 'lucide:building-2', path: '/minisite/business-info' },
          { label: 'minisite.pages.businessHours', icon: 'lucide:clock', path: '/minisite/business-info/hours' },
          { label: 'minisite.pages.social', icon: 'lucide:share-2', path: '/minisite/business-info/social' },
        ],
      },
      { label: 'general.payments', icon: 'lucide:credit-card', info: 'components.minisite.pages.payments', path: '/minisite/payments' },
      { label: 'minisite.newCustomers', icon: 'lucide:user-plus', info: 'components.minisite.pages.newCustomers', path: '/minisite/new-customers' },
      { label: 'minisite.pages.minimiseGaps', icon: 'lucide:minimize-2', info: 'components.minisite.pages.minimiseGaps', path: '/minisite/minimise-gaps' },
      { label: 'minisite.pages.terms', icon: 'lucide:scroll-text', info: 'components.minisite.pages.terms', path: '/minisite/terms-and-policy' },
      {
        label: 'minisite.pages.advanced',
        icon: 'lucide:wrench',
        info: 'components.minisite.pages.advanced',
        path: '/minisite/advanced',
        children: [
          { label: 'minisite.pages.domain', icon: 'lucide:link',   path: '/minisite/advanced/domain' },
          { label: 'minisite.pages.script', icon: 'lucide:braces', path: '/minisite/advanced/script' },
          { label: 'minisite.pages.seo',    icon: 'lucide:search', path: '/minisite/advanced/seo' },
        ],
      },
    ],
  },
]
